var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_355_2638",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_355_2638",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD80lEQVR4nO2dy2oUQRSGP4gaJaLL3ASV6At4WakYJCpZiLpQIRpQY9woxAsxcefO6EoCeQ3jZaHoAygSidGNG3VjvOWmKycQLSk4gRCmw5hUV5/pPh/8EIaZUPVPTXWd06eqwTAMwzAMwzAMw6iYGmA30AXcBR4Ab4EPwDQwK5qW197Ke+7IZ3bJ/zDKsAm4AjwGfgFuhfoJPAJ6gGYKzjqgE3gO/AlgbpLmgGfAGWAtBWK9jLTxFM1N0g/gFrCRHLMa6AWmMjB4sXwbrkubcsU+4J0CgxfrPdBGDvBz4hDwV4GpSfJtGwRqqVK2AC8VGOkq1GtgG1VGW6Blmossvyw8QJVwHPitwDS3TPlg6BTKuZjymthFku9DN0o5JsFB1ia5gGafRBl+XispMMelMI0cQgnbq/TC5/7jAtmStcm1sixyOddI1uvsIQUmuEjyQU1mYbXmiM8Flu/r/tgmrwLGFHTeRda72ImoXgWddhnpasx88qSCDruMNCkepE6fgs66jOVz2anffvoWsUMl+WIbRH0SRGRt9Je0b4t1Rja5vUwb+hUY7XU6TaOfR+rELHAkoQ31Ckz2epKWyc2RkkazS5jsaVJg8nzSKZVShisZThcLuanA5HldJgUeKzC5XVmWcDi0yb7EaibD6cJzWOGdm5nQ5We+Fs5GMmU92BnS6As2kkkaaOdCGu2rOm26oKwHt0Ma/dDmZJIG2v2QRo8VfHXhltBoSKM/RTQ5bRqBGwFzJh9DNi5UWrQPPYTKQk6EbFSob78BPTQE/JUGI49GN2s0OtTU0Y8e+jVOHXm6GDYFvoEQ9GJoyzviLO8sYCFOwGIhOHFC8K5A85nLSXp0oc6GNNrSpCQavSOk0Zb4J07iH9lbneZPsFSFyaagF8J5eiI0vFSB2VrqOrwupbXQ11BuUK/AYCdepJZSeBapE7NLmN2U9wIa5CiGWB0pJUwjWuo6OtIucvwa2ex+SdY3yt8aihzHY5z9UeQidCe6RgTqJDXoCqrJWIXoSCG2K6h6iLxZ6I2CTru8bxby7LXtb/EYVDDKXCTdI0NqZfuuy7leAWvImBbZmO5yqhlgK0poVZ6cd8uUD44OooyjOTwY5QRK6c7JUT9zUhOummNVPo2UNB7xs9TRPz+r9MLXSpWxGXihwDxXoUY0HOmzknX2oPII8q8EI5mvk0OF62MKTF0s36Y95IxVcqiIhhTrhGThfJtyS5108nMGBn+Xg7o3UCDWylEMT1MOdObkRmpH0Y6eL0ejbGAflqdRrNTcaflfl5TtMlBFjdSznQcGpBpoVB4FMrXg8SBT8tqovGdAdrH6z9rjQQzDMAzDMAzDMKiQfzC8UFrvTQJ7AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/GoBack.bc25885dab85d594b4551c6df9650670.svg";
export { ForwardRef as ReactComponent };